
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { PopularExplanation, SimiliarUsersExplanation } from '../../../../ts/models/IViewRecommendationInfo';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';

export interface RecommendationProps {
  explanationType: string;
  users: IUserInfo[];
  urls: SpacesSiteUrls;
}

function generateSimiliarUserNames(users: IUserInfo[], urls: SpacesSiteUrls) {
  // filter out undefined from users array
  let filteredUsers = users && users.filter(Boolean);
  if (filteredUsers && filteredUsers.length) {
    let userName = '';
    return (
    <div className={`${DetailsTooltipStyles.MetadataLinksDescription}, ${DetailsTooltipStyles.RecommendationUsernameAdjust}`}>
      {filteredUsers.map((user: IUserInfo, i) => {
          userName = user.displayName;
          // add comma between user names
          if (userName && i !== filteredUsers.length - 1) {
            userName += ',';
          }
          return <span key={i} className={DetailsTooltipStyles.MetadataLinks}><a href={ urls.userUrl(user.username, user.domainName) }>{userName}</a></span>;
        })}
    </div>
    );
  }
}

export function Recommendation(props: RecommendationProps) {
  const {explanationType, users, urls} = props;
  let explanationMessage = '';

  if (explanationType === PopularExplanation) {
    explanationMessage = Messages.vizRecommendationsPopularExplanationLong();
  } else if (explanationType === SimiliarUsersExplanation) {
    explanationMessage = Messages.vizRecommendationsSimiliarUsersExplanationLong();
  }

  if (explanationMessage) {
    return (
      <div className={DetailsTooltipStyles.MetadataSection}>
        <div className={DetailsTooltipStyles.MetadataTitle}>{Messages.vizRecommendationsExplanationBase()}</div>
        <div className={DetailsTooltipStyles.MetadataTextDescription}>{explanationMessage}</div>
        {generateSimiliarUserNames(users, urls)}
      </div>
    );
  }

  return null;
}
